import { CommonPageTWCard } from '@lemon8/web-app-shared/ssr';
import { useExperienceTitle } from '../shared/utils/use-experience-title';
import { useExperienceDesc } from '../shared/utils/use-experience-desc';

export const ExperienceTwitter = () => {
  const twitterCardInfo = {
    twCardTitle: useExperienceTitle(),
    twCardDesc: useExperienceDesc(),
    twCardImageSrc: '',
  };

  return <CommonPageTWCard {...twitterCardInfo} />;
};
